import fp from 'lodash/fp'
import { CertificateFeature } from 'todistukset-common/src/vtj/CertificateFeature.enum'
import CertificateTypes from 'todistukset-common/src/vtj/CertificateTypes.enum'

export const certificateTypeToTranslationKeyMap = {
  [CertificateTypes.ASUINPAIKKATODISTUS]: 'homeLocationCert',
  [CertificateTypes.ELOSSAOLOTODISTUS]: 'aliveCertificate',
  [CertificateTypes.AVIOLIITTOTODISTUS]: 'marriageCert',
  [CertificateTypes.SIVIILISAATYTODISTUS]: 'maritalStatusCert',
  [CertificateTypes.SYNTYMATODISTUS]: 'birthCert',
  [CertificateTypes.AETTODISTUS]: 'aettodistus',
  [CertificateTypes.UAETTODISTUS]: 'uaettodistus',
  [CertificateTypes.TODISTUSASUMISTIEDOILLA]: 'residenceCert',
  [CertificateTypes.TODISTUSHENKILOJAPERHESUHDETIEDOILLA]:
    'personAndFamilyRelationshipCert',
  [CertificateTypes.TODISTUSKUOLEMASTA]: 'deathCert',
}

export const homeLocationCertificate = (
  certificateType: CertificateTypes
): certificateType is CertificateTypes.ASUINPAIKKATODISTUS =>
  certificateType === CertificateTypes.ASUINPAIKKATODISTUS

export const aliveCertificate = (
  certificateType: CertificateTypes
): certificateType is CertificateTypes.ELOSSAOLOTODISTUS =>
  certificateType === CertificateTypes.ELOSSAOLOTODISTUS

export const marriageCertificate = (
  certificateType: CertificateTypes
): certificateType is CertificateTypes.AVIOLIITTOTODISTUS =>
  certificateType === CertificateTypes.AVIOLIITTOTODISTUS

export const getEnabledFeatures = ({
  certificateType,
  isAdult,
}: {
  certificateType: CertificateTypes
  isAdult: boolean
}): CertificateFeature[] => {
  switch (certificateType) {
    case CertificateTypes.ASUINPAIKKATODISTUS:
      return fp.compact([
        CertificateFeature.INCLUDE_HETU,
        CertificateFeature.INCLUDE_TRANSLATION,
        CertificateFeature.INCLUDE_APOSTILLE,
        CertificateFeature.ORDER_FOR_DEPENDANTS,
        CertificateFeature.UNDER_18_ALLOWED,
        CertificateFeature.FOREIGN_MUNICIPALITY_ALLOWED,
        CertificateFeature.EIDAS_ALLOWED,
        CertificateFeature.INCLUDE_KOTIKUNTA,
        CertificateFeature.INCLUDE_PERMANENT_ADDRESS,
        CertificateFeature.INCLUDE_NATIONALITY,
        isAdult && CertificateFeature.INCLUDE_PREVIOUS_PERMANENT_ADDRESSES,
        isAdult && CertificateFeature.INCLUDE_PREVIOUS_TEMPORARY_ADDRESSES,
        isAdult && CertificateFeature.INCLUDE_PREVIOUS_KOTIKUNTA,
        isAdult && CertificateFeature.INCLUDE_PREVIOUS_NAMES,
        isAdult && CertificateFeature.INCLUDE_MARITAL_STATUS,
      ])
    case CertificateTypes.ELOSSAOLOTODISTUS:
      return fp.compact([
        CertificateFeature.INCLUDE_HETU,
        CertificateFeature.INCLUDE_TRANSLATION,
        CertificateFeature.INCLUDE_APOSTILLE,
        CertificateFeature.ORDER_FOR_DEPENDANTS,
        CertificateFeature.UNDER_18_ALLOWED,
        CertificateFeature.INCLUDE_KOTIKUNTA,
        CertificateFeature.INCLUDE_PERMANENT_ADDRESS,
        isAdult && CertificateFeature.INCLUDE_PREVIOUS_NAMES,
      ])
    case CertificateTypes.AVIOLIITTOTODISTUS:
      return fp.compact([
        CertificateFeature.INCLUDE_HETU,
        CertificateFeature.INCLUDE_TRANSLATION,
        CertificateFeature.INCLUDE_APOSTILLE,
        CertificateFeature.FOREIGN_MUNICIPALITY_ALLOWED,
        CertificateFeature.INCLUDE_KOTIKUNTA,
        CertificateFeature.INCLUDE_PERMANENT_ADDRESS,
        CertificateFeature.INCLUDE_NUMBER_OF_MARRIAGES,
        isAdult && CertificateFeature.INCLUDE_PREVIOUS_MARRIAGES,
        isAdult && CertificateFeature.INCLUDE_PREVIOUS_NAMES,
        isAdult && CertificateFeature.INCLUDE_SPOUSE_PREVIOUS_NAMES,
      ])
    case CertificateTypes.SIVIILISAATYTODISTUS:
      return [
        CertificateFeature.FOREIGN_MUNICIPALITY_ALLOWED,
        CertificateFeature.INCLUDE_HETU,
        CertificateFeature.INCLUDE_TRANSLATION,
        CertificateFeature.INCLUDE_APOSTILLE,
        CertificateFeature.INCLUDE_KOTIKUNTA,
      ]
    case CertificateTypes.SYNTYMATODISTUS:
      return [
        CertificateFeature.ORDER_FOR_DEPENDANTS,
        CertificateFeature.FOREIGN_MUNICIPALITY_ALLOWED,
        CertificateFeature.EIDAS_ALLOWED,
        CertificateFeature.INCLUDE_HETU,
        CertificateFeature.INCLUDE_TRANSLATION,
        CertificateFeature.INCLUDE_APOSTILLE,
        CertificateFeature.INCLUDE_KOTIKUNTA,
        CertificateFeature.INCLUDE_PARENTS_PREVIOUS_NAMES,
        CertificateFeature.INCLUDE_PARENTS_HETU,
        CertificateFeature.INCLUDE_NATIONALITY,
        CertificateFeature.INCLUDE_PREVIOUS_NAMES,
      ]
    case CertificateTypes.AETTODISTUS:
      return [
        CertificateFeature.FOREIGN_MUNICIPALITY_ALLOWED,
        CertificateFeature.UNKNOWN_OR_NO_MUNICIPALITY_ALLOWED,
        CertificateFeature.ALAND_ALLOWED,
        CertificateFeature.MARRIED_DISALLOWED,
        CertificateFeature.REGISTERED_PARTNERSHIP_DISALLOWED,
      ]
    case CertificateTypes.UAETTODISTUS:
      return [
        CertificateFeature.FOREIGN_MUNICIPALITY_ALLOWED,
        CertificateFeature.UNKNOWN_OR_NO_MUNICIPALITY_ALLOWED,
        CertificateFeature.ALAND_ALLOWED,
        CertificateFeature.MARRIED_DISALLOWED,
        CertificateFeature.REGISTERED_PARTNERSHIP_DISALLOWED,
      ]
    case CertificateTypes.TODISTUSASUMISTIEDOILLA:
    case CertificateTypes.TODISTUSHENKILOJAPERHESUHDETIEDOILLA:
    case CertificateTypes.TODISTUSKUOLEMASTA:
      return []
  }
}
